import { post } from '@/utils/request'
import { getLocalJson } from '@/utils/request'
// import { getRoles } from '@/utils/auth'

// 接口前缀
// function apiFirstName() {
//   return getRoles()[0] || 'taoke'
// }

/**
 * 淘客cms网站配置信息
 */
export function taoke_cms_info() {
  return post('taoke_cms_info')
}

/**
 * 淘客cms网站配置信息设置
 * @param {String} title 店铺名字
 * @param {String} logo 店铺logo 必须https://img.zhutui.cn开头
 * @param {String} cms_member 开启会员功能 1开启 0 关闭
 * @param {String} cms_agent 开启代理功能 1 开启普通代理功能 0 关闭 (必须要先开会员功能，代理是会员的一种)
 * @param {String} domain 绑定域名，（一定要备案） 比如 lhb.zhutui.cn
 * @param {String} share_domain 绑定域名，分享专用域名，比如快站，（一定要备案） 比如 lhb.zhutui.cn
 * @param {String} ssl 使用ssl，1开通 0 不开通
 * @param {String} icpno 备案号，比如京ICP证030173号
 * @param {String} wx 客服微信号
 * @param {String} cms_pid CMS分享使用的PID （mm_xxxx_xxx_xxx）
 * @param {String} tkl_pid CMS转淘口令的PID （mm_xxxx_xxx_xxx）
 * @param {String} qq 客服QQ号
 * @param {String} wxgzh	微信公众号
 * @param {String} wxgzh_qrurl	微信公众号二维码url 必须https://img.zhutui.cn开头
 * @param {String} slogan 店铺口号
 * @param {String} jq_qq_code 加群代码
 * @param {String} qq_code qq联系我的代码
 * @param {String} ad 店铺公告
 * @param {String} footer 页脚
 * @param {String} tj_code 统计代码
 * @param {String} seo_title seo标题
 * @param {String} seo_description seo描述
 * @param {String} seo_keyword seo关键词
 */
export function taoke_cms_set(data) {
  return post('taoke_cms_set', data, {
    clear: false,
    config: {
      transformRequest: [(data) => {
        // data => formdata
        let formD = new FormData();
        Object.keys(data).forEach((key) => {

          if(data[key] !== null) {
            formD.append(key, data[key])
          }
        })
        return formD
      }],
    },
  })
}


/**
 * 淘客CMS设置（淘客利润分配设置,必须要开通对应的会员功能）
 *
 * @param {String} cms_member_return_commission_level_1 会员购买商品会员返佣1阈值
 * @param {String} cms_member_return_commission_level_2 会员购买商品会员返佣2阈值
 * @param {String} cms_member_return_commission_level_3 会员购买商品会员返佣3阈值
 * @param {String} cms_member_return_commission_1 会员购买商品会员返佣1 %
 * @param {String} cms_member_return_commission_2 会员购买商品会员返佣2 %
 * @param {String} cms_member_return_commission_3 会员购买商品会员返佣3 %
 * @param {String} cms_member_contribution_1 会员购买商品一级提成（给邀请他的人），奖励比例（占返佣%） %
 * @param {String} cms_member_contribution_2 会员购买商品二级提成（给邀请他的人），奖励比例（占返佣%） %
 * @param {String} cms_agent_return_commission_level_1 代理购买商品返给代理佣金1阈值
 * @param {String} cms_agent_return_commission_level_2 代理购买商品返给代理佣金2阈值
 * @param {String} cms_agent_return_commission_level_3 代理购买商品返给代理佣金3阈值
 * @param {String} cms_agent_return_commission_1 代理购买商品返给代理佣金1 %
 * @param {String} cms_agent_return_commission_2 代理购买商品返给代理佣金2 %
 * @param {String} cms_agent_return_commission_3 代理购买商品返给代理佣金3 %
 * @param {String} cms_agent_contribution_1 代理购买商品一级提成（给邀请他的人），奖励比例（占返佣%） %
 * @param {String} cms_agent_contribution_2 代理购买商品二级提成（给邀请他的人），奖励比例（占返佣%） %
 * @param {Number} cms_commission_level 当利润大于?元时，配合cms_commission_settle_delay_days使用 默认是0
 * @param {Number} cms_commission_settle_delay_days 结算延时天数，配合cms_commission_level使用 默认是0
 * @param {Number | null} cms_jd_commission_settle_finish_delay_days null:默认，0:立即结算 x:x天结算
 */
export function taoke_commission_set(data) {
  return post('taoke_commission_set', data)
}

/**
 * 淘客CMS设置（淘客搜索过滤设定）
 *
 * @param {String} filter_open 使用过滤 0 关 1开
 * @param {String} filter_source 来源过滤 tmall taobao 空字符是全部
 * @param {String} filter_salenum 销量过滤 >0的数字 0不过滤
 * @param {String} filter_commission 佣金过滤 >0的数字 0不过滤
 * @param {String} filter_dscr 动态描述过滤 >0的数字 0不过滤
 */
export function taoke_cms_filter_set(data) {
  return post('taoke_cms_filter_set', data, {
    clear: false,
  })
}

/**
 * 淘客VIP套餐购买升级(只升不降)
 *
 * @param {String} vip 升级等级 1 导购版 2用户中心版 3返利代理版 4尊享版
 * @param {String} vip_time_length 购买时长 用户中心版 返利代理版 单位是月 尊享版 单位是年
 */
export function taoke_vip_upgrade(data) {
  return post('taoke_vip_upgrade', data)
}

/**
 * 淘客VIP套餐购买升级(只升不降)
 *
 * @param {String} vip 降级等级 1 导购版 2用户中心版 3返利代理版 4尊享版
 */
export function taoke_vip_downgrade(data) {
  return post('taoke_vip_downgrade', data)
}


/**
 * 获取版本升级信息
 */
export function get_ver_info() {
  return getLocalJson('/upgrade.json')
}


/**
 * 淘客订单拉取限制
 * @param {String} date 限制时间 YYYY-MM-DD HH:NN:SS
 */
export function taoke_taobao_order_limit_date_set(date) {
  return post('taoke_taobao_order_limit_date_set', { date })
}

/**
 * 淘客修改文案模板
 * @param {String} template 模板内容
 * @param {String} type 模板类型 ad_qq_template 品库QQ分享推广文案模板,ad_wx_template 品库微信分享推广文案模板 ,ad_pk_template 默认文案模板
 */
export function taoke_ad_template_set(data) {
  return post('taoke_ad_template_set', data)
}


/**
 * 淘客查看代理申请记录
 * @param {String} telephone 申请人手机号码
 * @param {String} status 状态 1已经通过 2已经拒绝 0申请中
 * @param {String} page 页码
 * @param {String} pagesize 分页大小
 */
export function taoke_cms_member_agent_apply_list(data) {
  return post('taoke_cms_member_agent_apply_list', data)
}

/**
 * 淘客查看代理申请审核
 * @param {String} id 申请id
 * @param {String} agree 1 通过 2 拒绝
 * @param {String} reject_reason 拒绝理由
 */
export function taoke_cms_member_agent_apply_confirm(data) {
  return post('taoke_cms_member_agent_apply_confirm', data)
}

/**
 * 淘客CMS弹窗功能设置
 * @param {String} popupwin_open 是否开启弹屏广告功能 0 否 1 是 默认是0
 * @param {String} popupwin_bg_picture 弹窗背景图片
 * @param {String} popupwin_ad_text 弹窗文本
 * @param {String} popupwin_button_text 弹窗按钮文本
 * @param {String} popupwin_button_url 弹窗按钮链接 输入#gfhb# 表示去官方红包插件
 * @param {String} popupwin_time_begin 弹窗开始时间 \d{4,4}-\d{2,2}-\d{2,2} \d{2,2}:\d{2,2}:\d{2,2}
 * @param {String} popupwin_time_end 弹窗结束时间 \d{4,4}-\d{2,2}-\d{2,2} \d{2,2}:\d{2,2}:\d{2,2}
 * @param {String} popupwin_type 弹窗间隔 可以输入 24h 0h 分别表示 间隔24小时，每次
 */
export function taoke_cms_popupwin_set(data) {
  return post('taoke_cms_popupwin_set', data)
}

/**
 * 淘客CMS设置开启模块
 * @param {String} member_modules 普通会员模块清单 ,隔开
 * @param {String} agent_modules 代理模块清单 ,隔开
 * @param {String} default_modules 默认模块清单 ,隔开
 */
export function taoke_cms_modules_open_set(data) {
  return post('taoke_cms_modules_open_set', data, { clear: false })
}
